/* eslint-disable */

const colors = ['#C39F64', '#8B965D', '#5A8763', '#36746A', '#2A5E67', '#2F4858'];
const formatter = new Intl.NumberFormat('da', {
    style: 'currency',
    currency: 'DKK',
});
const formatDKK = (val) => {
    return formatter.format(val);
};

const reduceArrayEvenlyTo = (data, numberOfPoints) => {
    const out = [];
    data.reverse();
    const delta = Math.ceil(data.length / numberOfPoints);
    for (i = 0; i < data.length; i = i + delta) {
        out.push(data[i]);
    }
    out.reverse();
    return out;
};

const initDashboards = (data) => {
    const ctx = document.getElementById('balanceChart').getContext('2d');

    const totalBalance = data.map((row) => {
        return { y: row.balanceTotal, x: moment(row.createdAt).format('YYYY-MM-DD HH:mm') };
    });
    const balanceAarhus = data.map((row) => {
        return { y: row.balanceAarhus, x: moment(row.createdAt).format('YYYY-MM-DD HH:mm') };
    });
    const balanceCph = data.map((row) => {
        return { y: row.balanceCph, x: moment(row.createdAt).format('YYYY-MM-DD HH:mm') };
    });
    const options = {
        type: 'line',
        data: {
            datasets: [
                {
                    label: 'Total balance',
                    data: totalBalance,
                    borderColor: colors[0],
                    fill: null,
                },
                {
                    label: 'Balance CPH',
                    data: balanceCph,
                    borderColor: colors[1],
                    fill: null,
                },
                {
                    label: 'Balance Aarhus',
                    data: balanceAarhus,
                    borderColor: colors[2],
                    fill: null,
                },
            ],
        },
        options: {
            title: {
                display: true,
                text: 'Balance',
            },
            tooltips: {
                callbacks: {
                    label(tooltipItem, data) {
                        return formatDKK(tooltipItem.value);
                    },
                },
            },
            scales: {
                yAxes: [
                    {
                        ticks: {
                            beginAtZero: true,
                            callback(value, index, values) {
                                return formatDKK(value);
                            },
                            suggestedMax: Math.max(...totalBalance.map((r) => r.y)) + 1000000,
                        },
                    },
                ],
                xAxes: [
                    {
                        type: 'time',
                        time: {
                            unit: 'day',
                        },
                    },
                ],
            },
        },
    };
    new Chart(ctx, options);
};
